
import { Component, Prop, Vue } from "vue-property-decorator";

const MODEL_CLASS = "loader";

@Component
export default class Loader extends Vue {
  @Prop({ type: Boolean, default: false }) readonly stretch!: boolean;
  @Prop({ type: Boolean, default: false }) readonly absolute!: boolean;
  @Prop({ type: String, default: "" }) readonly label!: string;

  get classes() {
    const { stretch, absolute } = this;

    return {
      [`${MODEL_CLASS}_stretch`]: stretch,
      [`${MODEL_CLASS}_absolute`]: absolute,
    };
  }
}
